import { Button, Grid, MenuItem } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { isEqual } from 'lodash'
import React, { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import { TextField } from 'formik-material-ui'

const retornaPrograma = (u = []) => ({
  idPrograma: u[0] || undefined,
  idProgramaPai: u[1]?.[0],
  programaPai: u[1] || undefined,
  dsTitulo: u[2] || '',
  dsSubtitulo: u[3] || '',
  dsLink: u[4] || '',
  dsIcone: u[5] || '',
  nmPackage: u[6] || '',
  nrOrdenacao: u[7] || undefined,
  snAtivo: u[8] ? 'S' : 'N',
})

const listaTpUsuarios = [
  { icone: 'glyphicon glyphicon-asterisk' },
  { icone: 'glyphicon glyphicon-plus' },
  { icone: 'glyphicon glyphicon-euro' },
  { icone: 'glyphicon glyphicon-eur' },
  { icone: 'glyphicon glyphicon-minus' },
  { icone: 'glyphicon glyphicon-cloud' },
  { icone: 'glyphicon glyphicon-envelope' },
  { icone: 'glyphicon glyphicon-pencil' },
  { icone: 'glyphicon glyphicon-glass' },
  { icone: 'glyphicon glyphicon-music' },
  { icone: 'glyphicon glyphicon-search' },
  { icone: 'glyphicon glyphicon-heart' },
  { icone: 'glyphicon glyphicon-star' },
  { icone: 'glyphicon glyphicon-star-empty' },
  { icone: 'glyphicon glyphicon-user' },
  { icone: 'glyphicon glyphicon-film' },
  { icone: 'glyphicon glyphicon-th-large' },
  { icone: 'glyphicon glyphicon-th' },
  { icone: 'glyphicon glyphicon-th-list' },
  { icone: 'glyphicon glyphicon-ok' },
  { icone: 'glyphicon glyphicon-remove' },
  { icone: 'glyphicon glyphicon-zoom-in' },
  { icone: 'glyphicon glyphicon-zoom-out' },
  { icone: 'glyphicon glyphicon-off' },
  { icone: 'glyphicon glyphicon-signal' },
  { icone: 'glyphicon glyphicon-cog' },
  { icone: 'glyphicon glyphicon-trash' },
  { icone: 'glyphicon glyphicon-home' },
  { icone: 'glyphicon glyphicon-file' },
  { icone: 'glyphicon glyphicon-time' },
  { icone: 'glyphicon glyphicon-road' },
  { icone: 'glyphicon glyphicon-download-alt' },
  { icone: 'glyphicon glyphicon-download' },
  { icone: 'glyphicon glyphicon-uploadv' },
  { icone: 'glyphicon glyphicon-inbox' },
  { icone: 'glyphicon glyphicon-play-circle' },
  { icone: 'glyphicon glyphicon-repeatv' },
  { icone: 'glyphicon glyphicon-refresh' },
  { icone: 'glyphicon glyphicon-list-alt' },
  { icone: 'glyphicon glyphicon-lock' },
  { icone: 'glyphicon glyphicon-flag' },
  { icone: 'glyphicon glyphicon-headphones' },
  { icone: 'glyphicon glyphicon-volume-off' },
  { icone: 'glyphicon glyphicon-volume-down' },
  { icone: 'glyphicon glyphicon-volume-up' },
  { icone: 'glyphicon glyphicon-qrcode' },
  { icone: 'glyphicon glyphicon-barcode' },
  { icone: 'glyphicon glyphicon-tag' },
  { icone: 'glyphicon glyphicon-tags' },
  { icone: 'glyphicon glyphicon-book' },
  { icone: 'glyphicon glyphicon-bookmark' },
  { icone: 'glyphicon glyphicon-print' },
  { icone: 'glyphicon glyphicon-camerav' },
  { icone: 'glyphicon glyphicon-font' },
  { icone: 'glyphicon glyphicon-bold' },
  { icone: 'glyphicon glyphicon-italic' },
  { icone: 'glyphicon glyphicon-text-height' },
  { icone: 'glyphicon glyphicon-text-width' },
  { icone: 'glyphicon glyphicon-align-left' },
  { icone: 'glyphicon glyphicon-align-center' },
  { icone: 'glyphicon glyphicon-align-right' },
  { icone: 'glyphicon glyphicon-align-justify' },
  { icone: 'glyphicon glyphicon-list' },
  { icone: 'glyphicon glyphicon-indent-left' },
  { icone: 'glyphicon glyphicon-indent-right' },
  { icone: 'glyphicon glyphicon-facetime-video' },
  { icone: 'glyphicon glyphicon-picture' },
  { icone: 'glyphicon glyphicon-map-marker' },
  { icone: 'glyphicon glyphicon-adjust' },
  { icone: 'glyphicon glyphicon-tint' },
  { icone: 'glyphicon glyphicon-editv' },
  { icone: 'glyphicon glyphicon-share' },
  { icone: 'glyphicon glyphicon-check' },
  { icone: 'glyphicon glyphicon-move' },
  { icone: 'glyphicon glyphicon-step-backward' },
  { icone: 'glyphicon glyphicon-fast-backward' },
  { icone: 'glyphicon glyphicon-backward' },
  { icone: 'glyphicon glyphicon-play' },
  { icone: 'glyphicon glyphicon-pause' },
  { icone: 'glyphicon glyphicon-stop' },
  { icone: 'glyphicon glyphicon-forward' },
  { icone: 'glyphicon glyphicon-fast-forward' },
  { icone: 'glyphicon glyphicon-step-forward' },
  { icone: 'glyphicon glyphicon-eject' },
  { icone: 'glyphicon glyphicon-chevron-left' },
  { icone: 'glyphicon glyphicon-chevron-right' },
  { icone: 'glyphicon glyphicon-plus-sign' },
  { icone: 'glyphicon glyphicon-minus-sign' },
  { icone: 'glyphicon glyphicon-remove-sign' },
  { icone: 'glyphicon glyphicon-ok-sign' },
  { icone: 'glyphicon glyphicon-question-sign' },
  { icone: 'glyphicon glyphicon-info-sign' },
  { icone: 'glyphicon glyphicon-screenshot' },
  { icone: 'glyphicon glyphicon-remove-circle' },
  { icone: 'glyphicon glyphicon-ok-circle' },
  { icone: 'glyphicon glyphicon-ban-circle' },
  { icone: 'glyphicon glyphicon-arrow-left' },
  { icone: 'glyphicon glyphicon-arrow-right' },
  { icone: 'glyphicon glyphicon-arrow-up' },
  { icone: 'glyphicon glyphicon-arrow-down' },
  { icone: 'glyphicon glyphicon-share-alt' },
  { icone: 'glyphicon glyphicon-resize-full' },
  { icone: 'glyphicon glyphicon-resize-small' },
  { icone: 'glyphicon glyphicon-exclamation-sign' },
  { icone: 'glyphicon glyphicon-gift' },
  { icone: 'glyphicon glyphicon-leaf' },
  { icone: 'glyphicon glyphicon-fire' },
  { icone: 'glyphicon glyphicon-eye-open' },
  { icone: 'glyphicon glyphicon-eye-close' },
  { icone: 'glyphicon glyphicon-warning-sign' },
  { icone: 'glyphicon glyphicon-plane' },
  { icone: 'glyphicon glyphicon-calendar' },
  { icone: 'glyphicon glyphicon-random' },
  { icone: 'glyphicon glyphicon-comment' },
  { icone: 'glyphicon glyphicon-magnet' },
  { icone: 'glyphicon glyphicon-chevron-up' },
  { icone: 'glyphicon glyphicon-chevron-down' },
  { icone: 'glyphicon glyphicon-retweet' },
  { icone: 'glyphicon glyphicon-shopping-cart' },
  { icone: 'glyphicon glyphicon-folder-close' },
  { icone: 'glyphicon glyphicon-folder-open' },
  { icone: 'glyphicon glyphicon-resize-vertical' },
  { icone: 'glyphicon glyphicon-resize-horizontal' },
  { icone: 'glyphicon glyphicon-hdd' },
  { icone: 'glyphicon glyphicon-bullhorn' },
  { icone: 'glyphicon glyphicon-bell' },
  { icone: 'glyphicon glyphicon-certificate' },
  { icone: 'glyphicon glyphicon-thumbs-up' },
  { icone: 'glyphicon glyphicon-thumbs-down' },
  { icone: 'glyphicon glyphicon-hand-right' },
  { icone: 'glyphicon glyphicon-hand-left' },
  { icone: 'glyphicon glyphicon-hand-up' },
  { icone: 'glyphicon glyphicon-hand-down' },
  { icone: 'glyphicon glyphicon-circle-arrow-right' },
  { icone: 'glyphicon glyphicon-circle-arrow-left' },
  { icone: 'glyphicon glyphicon-circle-arrow-up' },
  { icone: 'glyphicon glyphicon-circle-arrow-down' },
  { icone: 'glyphicon glyphicon-globe' },
  { icone: 'glyphicon glyphicon-wrench' },
  { icone: 'glyphicon glyphicon-tasks' },
  { icone: 'glyphicon glyphicon-filter' },
  { icone: 'glyphicon glyphicon-briefcase' },
  { icone: 'glyphicon glyphicon-fullscreen' },
  { icone: 'glyphicon glyphicon-dashboard' },
  { icone: 'glyphicon glyphicon-paperclip' },
  { icone: 'glyphicon glyphicon-heart-empty' },
  { icone: 'glyphicon glyphicon-link' },
  { icone: 'glyphicon glyphicon-phone' },
  { icone: 'glyphicon glyphicon-pushpin' },
  { icone: 'glyphicon glyphicon-usd' },
  { icone: 'glyphicon glyphicon-gbp' },
  { icone: 'glyphicon glyphicon-sort' },
  { icone: 'glyphicon glyphicon-sort-by-alphabet' },
  { icone: 'glyphicon glyphicon-sort-by-alphabet-alt' },
  { icone: 'glyphicon glyphicon-sort-by-order' },
  { icone: 'glyphicon glyphicon-sort-by-order-alt' },
  { icone: 'glyphicon glyphicon-sort-by-attributes' },
  { icone: 'glyphicon glyphicon-sort-by-attributes-alt' },
  { icone: 'glyphicon glyphicon-unchecked' },
  { icone: 'glyphicon glyphicon-expand' },
  { icone: 'glyphicon glyphicon-collapse-down' },
  { icone: 'glyphicon glyphicon-collapse-up' },
  { icone: 'glyphicon glyphicon-log-in' },
  { icone: 'glyphicon glyphicon-flash' },
  { icone: 'glyphicon glyphicon-log-out' },
  { icone: 'glyphicon glyphicon-new-window' },
  { icone: 'glyphicon glyphicon-record' },
  { icone: 'glyphicon glyphicon-save' },
  { icone: 'glyphicon glyphicon-open' },
  { icone: 'glyphicon glyphicon-saved' },
  { icone: 'glyphicon glyphicon-import' },
  { icone: 'glyphicon glyphicon-export' },
  { icone: 'glyphicon glyphicon-send' },
  { icone: 'glyphicon glyphicon-floppy-disk' },
  { icone: 'glyphicon glyphicon-floppy-saved' },
  { icone: 'glyphicon glyphicon-floppy-remove' },
  { icone: 'glyphicon glyphicon-floppy-save' },
  { icone: 'glyphicon glyphicon-floppy-open' },
  { icone: 'glyphicon glyphicon-credit-card' },
  { icone: 'glyphicon glyphicon-transfer' },
  { icone: 'glyphicon glyphicon-cutlery' },
  { icone: 'glyphicon glyphicon-header' },
  { icone: 'glyphicon glyphicon-compressed' },
  { icone: 'glyphicon glyphicon-earphone' },
  { icone: 'glyphicon glyphicon-phone-alt' },
  { icone: 'glyphicon glyphicon-tower' },
  { icone: 'glyphicon glyphicon-stats' },
  { icone: 'glyphicon glyphicon-sd-video' },
  { icone: 'glyphicon glyphicon-hd-video' },
  { icone: 'glyphicon glyphicon-subtitles' },
  { icone: 'glyphicon glyphicon-sound-stereo' },
  { icone: 'glyphicon glyphicon-sound-dolby' },
  { icone: 'glyphicon glyphicon-sound-5-1' },
  { icone: 'glyphicon glyphicon-sound-6-1' },
  { icone: 'glyphicon glyphicon-sound-7-1' },
  { icone: 'glyphicon glyphicon-copyright-mark' },
  { icone: 'glyphicon glyphicon-registration-mark' },
  { icone: 'glyphicon glyphicon-cloud-download' },
  { icone: 'glyphicon glyphicon-cloud-upload' },
  { icone: 'glyphicon glyphicon-tree-conifer' },
  { icone: 'glyphicon glyphicon-tree-deciduous' },
  { icone: 'glyphicon glyphicon-cd' },
  { icone: 'glyphicon glyphicon-save-file' },
  { icone: 'glyphicon glyphicon-open-file' },
  { icone: 'glyphicon glyphicon-level-up' },
  { icone: 'glyphicon glyphicon-copy' },
  { icone: 'glyphicon glyphicon-paste' },
  { icone: 'glyphicon glyphicon-alert' },
  { icone: 'glyphicon glyphicon-equalizer' },
  { icone: 'glyphicon glyphicon-king' },
  { icone: 'glyphicon glyphicon-queen' },
  { icone: 'glyphicon glyphicon-pawn' },
  { icone: 'glyphicon glyphicon-bishop' },
  { icone: 'glyphicon glyphicon-knight' },
  { icone: 'glyphicon glyphicon-baby-formula' },
  { icone: 'glyphicon glyphicon-tent' },
  { icone: 'glyphicon glyphicon-blackboard' },
  { icone: 'glyphicon glyphicon-bed' },
  { icone: 'glyphicon glyphicon-apple' },
  { icone: 'glyphicon glyphicon-erase' },
  { icone: 'glyphicon glyphicon-hourglass' },
  { icone: 'glyphicon glyphicon-lamp' },
  { icone: 'glyphicon glyphicon-duplicate' },
  { icone: 'glyphicon glyphicon-piggy-bank' },
  { icone: 'glyphicon glyphicon-scissors' },
  { icone: 'glyphicon glyphicon-bitcoin' },
  { icone: 'glyphicon glyphicon-btc' },
  { icone: 'glyphicon glyphicon-xbt' },
  { icone: 'glyphicon glyphicon-yen' },
  { icone: 'glyphicon glyphicon-jpy' },
  { icone: 'glyphicon glyphicon-ruble' },
  { icone: 'glyphicon glyphicon-rub' },
  { icone: 'glyphicon glyphicon-scale' },
  { icone: 'glyphicon glyphicon-ice-lolly' },
  { icone: 'glyphicon glyphicon-ice-lolly-tasted' },
  { icone: 'glyphicon glyphicon-education' },
  { icone: 'glyphicon glyphicon-option-horizontal' },
  { icone: 'glyphicon glyphicon-option-vertical' },
  { icone: 'glyphicon glyphicon-menu-hamburger' },
  { icone: 'glyphicon glyphicon-modal-window' },
  { icone: 'glyphicon glyphicon-oil' },
  { icone: 'glyphicon glyphicon-grain' },
  { icone: 'glyphicon glyphicon-sunglasses' },
  { icone: 'glyphicon glyphicon-text-size' },
  { icone: 'glyphicon glyphicon-text-color' },
  { icone: 'glyphicon glyphicon-text-background' },
  { icone: 'glyphicon glyphicon-object-align-top' },
  { icone: 'glyphicon glyphicon-object-align-bottom' },
  { icone: 'glyphicon glyphicon-object-align-horizontal' },
  { icone: 'glyphicon glyphicon-object-align-left' },
  { icone: 'glyphicon glyphicon-object-align-vertical' },
  { icone: 'glyphicon glyphicon-object-align-right' },
  { icone: 'glyphicon glyphicon-triangle-right' },
  { icone: 'glyphicon glyphicon-triangle-left' },
  { icone: 'glyphicon glyphicon-triangle-bottom' },
  { icone: 'glyphicon glyphicon-triangle-top' },
  { icone: 'glyphicon glyphicon-console' },
  { icone: 'glyphicon glyphicon-superscript' },
  { icone: 'glyphicon glyphicon-subscript' },
  { icone: 'glyphicon glyphicon-menu-left' },
  { icone: 'glyphicon glyphicon-menu-right' },
  { icone: 'glyphicon glyphicon-menu-down' },
  { icone: 'glyphicon glyphicon-menu-up' },
]

const Edicao = ({ programaAberto, voltar }) => {
  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <Formik
      enableReinitialize
      initialValues={retornaPrograma(programaAberto)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, setFieldValue }) => (
        <Form style={{ width: '100%', padding: 15 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={2}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Programa Pai"
                metodo="buscaProgramaPai"
                disabled={isSubmitting}
                value={programaAberto[1]}
                onChange={(_, val) => {
                  setFieldValue(
                    'idProgramaPai',
                    Array.isArray(val) ? val[0][0] : '',
                  )
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={5}>
              <Field
                component={TextField}
                name="dsTitulo"
                label="Título"
                disabled={isSubmitting}
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={6} xl={5}>
              <Field
                component={TextField}
                name="dsSubtitulo"
                label="Subtítulo"
                disabled={isSubmitting}
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={6}>
              <Field
                component={TextField}
                name="dsLink"
                label="Link"
                disabled={isSubmitting}
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Field
                name="dsIcone"
                component={TextField}
                label="Ícone"
                disabled={isSubmitting}
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
                select
              >
                {listaTpUsuarios.map((option) => {
                  return (
                    <MenuItem
                      key={option.icone}
                      value={option.icone}
                      className="flex gap-4"
                    >
                      <span
                        className={option.icone}
                        style={{ marginRight: 15 }}
                      />
                      {option.icone}
                    </MenuItem>
                  )
                })}
              </Field>
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <Field
                component={TextField}
                name="nmPackage"
                label="Package"
                size="small"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <Field
                component={TextField}
                name="nrOrdenacao"
                label="Ordenação"
                size="small"
                disabled={isSubmitting}
                type="number"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <Field
                name="snAtivo"
                component={TextField}
                label="Situação"
                size="small"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
                select
              >
                <MenuItem key={0} value={'S'} className="flex gap-4">
                  Ativo
                </MenuItem>
                <MenuItem key={1} value={'N'} className="flex gap-4">
                  Inativo
                </MenuItem>
              </Field>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
